import Combined from '@/layouts/combined';
import { getFaviconLinks } from '@/mixins/getHead';

export default {
    extends: Combined,

    head() {
        return {
            link: [
                ...getFaviconLinks(
                    '/themes/edeka/edeka-favicon-32x32.ico',
                    '/themes/edeka/edeka-favicon.svg',
                    '/themes/edeka/edeka-apple-touch-icon.png'
                )
            ]
        };
    }
};
